export default {
    sharedHeader: {
        routeLinks: {
            car: {
                displayText: 'Cars',
                url: '/cars',
                additionalProps: {
                    rel: 'external',
                },
            },
            van: {
                displayText: 'Vans',
                url: '/vans',
                additionalProps: {
                    rel: 'external',
                },
            },
            bike: {
                displayText: 'Bikes',
                url: '/bikes',
                additionalProps: {
                    rel: 'external',
                },
            },
            motorhome: {
                displayText: 'Motorhomes',
                url: '/motorhomes',
                additionalProps: {
                    rel: 'external',
                },
            },
            caravan: {
                displayText: 'Caravans',
                url: '/caravans',
                additionalProps: {
                    rel: 'external',
                },
            },
            truck: {
                displayText: 'Trucks',
                url: '/trucks',
                additionalProps: {
                    rel: 'external',
                },
            },
            farm: {
                displayText: 'Farm',
                url: '/farm',
                additionalProps: {
                    rel: 'external',
                },
            },
            plant: {
                displayText: 'Plant',
                url: '/plant',
                additionalProps: {
                    rel: 'external',
                },
            },
            cycle: {
                displayText: 'Electric bikes',
                url: '/electric-bikes',
                additionalProps: {
                    rel: 'external',
                },
            },
        },
        save: {
            displayText: 'Saved',
            url: '/secure/saved-adverts',
            additionalProps: {
                rel: 'external',
            },
        },
        account: {
            signedOut: {
                desktopDisplayText: 'Sign in',
                mobileDisplayText: 'Sign in or create an account',
                additionalProps: {
                    rel: 'external',
                },
                url: '/secure/signin',
            },
            signedIn: {
                mobileDisplayText: 'See my account',
                desktopDisplayText: 'Account',
                mobileAccountText: 'My Account',
                additionalProps: {
                    rel: 'external',
                },
                url: '/secure/my-auto-trader',
            },
        },
    },
    cars: {
        header: {
            primaryNav: [
                {
                    displayText: 'Used cars',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/cars/used',
                    navDataTestId: 'nav-used-cars',
                },
                {
                    displayText: 'New cars',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/cars/new',
                    navDataTestId: 'nav-new-cars',
                },
                {
                    displayText: 'Sell your car',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/cars/sell-my-car',
                    navDataTestId: 'nav-sell-your-car',
                },
                {
                    displayText: 'Value your car',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/cars/valuation',
                    navDataTestId: 'nav-value-your-car',
                },
                {
                    displayText: 'Car reviews',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/cars/reviews',
                    navDataTestId: 'nav-car-reviews',
                },
                {
                    displayText: 'Car leasing',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/cars/leasing',
                    navDataTestId: 'nav-car-leasing',
                },
                {
                    displayText: 'Electric cars',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/cars/electric',
                    navDataTestId: 'nav-electric-cars',
                },
                {
                    displayText: 'Buy a car online',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/cars/buying-online',
                    navDataTestId: 'nav-buy-a-car-online',
                },
            ],
            sellMyVehicle: {
                desktopDisplayText: 'Sell my car',
                mobileDisplayText: 'Sell',
                additionalProps: {
                    rel: 'external',
                },
                url: '/cars/sell-my-car',
            },
            search: {
                displayText: 'Search',
                url: '/search-form',
                additionalProps: {
                    rel: 'external',
                },
            },
        },
    },
    vans: {
        header: {
            primaryNav: [
                {
                    displayText: 'Used vans',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/vans/used-vans',
                },
                {
                    displayText: 'New vans',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/vans/new-vans',
                },
                {
                    displayText: 'Sell your van',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/vans/sell',
                },
                {
                    displayText: 'Van reviews',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/vans/content',
                },
                {
                    displayText: 'Van leasing',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/vans/leasing',
                },
                {
                    displayText: 'Finance',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/vans/finance',
                },
                {
                    displayText: 'Electric vans',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/vans/electric',
                },
                {
                    displayText: 'Insurance',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/vans/insurance',
                },
            ],
            sellMyVehicle: {
                desktopDisplayText: 'Sell my van',
                mobileDisplayText: 'Sell',
                additionalProps: {
                    rel: 'external',
                },
                url: '/vans/sell',
            },
            search: {
                displayText: 'Search',
                url: '/vans/search-form',
                additionalProps: {
                    rel: 'external',
                },
            },
        },
    },
    bikes: {
        header: {
            primaryNav: [
                {
                    displayText: 'Used bikes',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/bikes/used-bikes',
                },
                {
                    displayText: 'New bikes',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/bikes/new-bikes',
                },
                {
                    displayText: 'Sell your bike',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/bikes/sell',
                },
                {
                    displayText: 'Bike reviews',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/bikes/content',
                },
                {
                    displayText: 'Electric motorbikes',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/bikes/electric',
                },
                {
                    displayText: 'Finance',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/bikes/finance',
                },
                {
                    displayText: 'Insurance',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/bikes/insurance',
                },
            ],
            sellMyVehicle: {
                desktopDisplayText: 'Sell my bike',
                mobileDisplayText: 'Sell',
                additionalProps: {
                    rel: 'external',
                },
                url: '/bikes/sell',
            },
            search: {
                displayText: 'Search',
                url: '/bikes/search-form',
                additionalProps: {
                    rel: 'external',
                },
            },
        },
    },
    motorhomes: {
        header: {
            primaryNav: [
                {
                    displayText: 'Used motorhomes',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/motorhomes/used-motorhomes',
                },
                {
                    displayText: 'New motorhomes',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/motorhomes/new-motorhomes',
                },
                {
                    displayText: 'Sell your motorhome',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/motorhomes/sell',
                },
                {
                    displayText: 'Motorhome reviews',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/motorhomes/content',
                },
            ],
            sellMyVehicle: {
                desktopDisplayText: 'Sell',
                mobileDisplayText: 'Sell',
                additionalProps: {
                    rel: 'external',
                },
                url: '/motorhomes/sell',
            },
            search: {
                displayText: 'Search',
                url: '/motorhomes/search-form',
                additionalProps: {
                    rel: 'external',
                },
            },
        },
    },
    caravans: {
        header: {
            primaryNav: [
                {
                    displayText: 'Used caravans',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/caravans/used-caravans',
                },
                {
                    displayText: 'New caravans',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/caravans/new-caravans',
                },
                {
                    displayText: 'Sell your caravan',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/caravans/sell',
                },
                {
                    displayText: 'Caravan reviews',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/caravans/content',
                },
            ],
            sellMyVehicle: {
                desktopDisplayText: 'Sell',
                mobileDisplayText: 'Sell',
                additionalProps: {
                    rel: 'external',
                },
                url: '/caravans/sell',
            },
            search: {
                displayText: 'Search',
                url: '/caravans/search-form',
                additionalProps: {
                    rel: 'external',
                },
            },
        },
    },
    trucks: {
        header: {
            primaryNav: [
                {
                    displayText: 'Used trucks',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/trucks/used-trucks',
                },
                {
                    displayText: 'New trucks',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/trucks/new-trucks',
                },
                {
                    displayText: 'Sell your truck',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/trucks/sell',
                },
                {
                    displayText: 'Truck reviews',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/trucks/content',
                },
            ],
            sellMyVehicle: {
                desktopDisplayText: 'Sell',
                mobileDisplayText: 'Sell',
                additionalProps: {
                    rel: 'external',
                },
                url: '/trucks/sell',
            },
            search: {
                displayText: 'Search',
                url: '/truck-search',
                additionalProps: {
                    rel: 'external',
                },
            },
        },
    },
    plant: {
        header: {
            primaryNav: [
                {
                    name: 'used',
                    displayText: 'Used plant machinery',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/plant/used-plant-machinery',
                },
                {
                    name: 'new',
                    displayText: 'New plant machinery',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/plant/new-plant-machinery',
                },
                {
                    displayText: 'Sell your plant machinery',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/plant/sell',
                },
                {
                    name: 'content',
                    displayText: 'Plant machinery reviews',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/plant/content',
                },
            ],
            sellMyVehicle: {
                desktopDisplayText: 'Sell',
                mobileDisplayText: 'Sell',
                additionalProps: {
                    rel: 'external',
                },
                url: '/plant/sell',
            },
            search: {
                displayText: 'Search',
                url: '/plant-search',
                additionalProps: {
                    rel: 'external',
                },
            },
        },
    },
    farm: {
        header: {
            primaryNav: [
                {
                    name: 'used',
                    displayText: 'Used farm machinery',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/farm/used-farm-machinery',
                },
                {
                    name: 'new',
                    displayText: 'New farm machinery',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/farm/new-farm-machinery',
                },
                {
                    displayText: 'Sell your farm machinery',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/farm/sell',
                },
                {
                    name: 'content',
                    displayText: 'Farm machinery reviews',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/farm/content',
                },
            ],
            sellMyVehicle: {
                desktopDisplayText: 'Sell',
                mobileDisplayText: 'Sell',
                additionalProps: {
                    rel: 'external',
                },
                url: '/farm/sell',
            },
            search: {
                displayText: 'Search',
                url: '/farm-search',
                additionalProps: {
                    rel: 'external',
                },
            },
        },
    },
    cycles: {
        header: {
            primaryNav: [
                {
                    name: 'new',
                    displayText: 'New electric bikes',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/electric-bikes/new',
                },
                {
                    name: 'content',
                    displayText: 'Electric bike reviews',
                    additionalProps: {
                        rel: 'external',
                    },
                    url: '/electric-bikes/content',
                },
            ],
            sellMyVehicle: {
                desktopDisplayText: '',
                mobileDisplayText: '',
                additionalProps: {
                    rel: 'external',
                },
                url: '/electric-bikes',
            },
            search: {
                displayText: 'Search',
                url: '/electric-bike-search',
                additionalProps: {
                    rel: 'external',
                },
            },
        },
    },
};
